module.exports = "/static/assets/84aefa938153e51579474dadf72c525b.png";